import Vue from 'vue';
import App from './App.vue';

import i18n from './assets/i18n';
import BaiduMap from 'vue-baidu-map';
import store from './store'
//DOM型xss预防
// import xss from 'xss';
import xssFilter from '@/utils/xss';
Vue.prototype.xss = (val) => xssFilter.process(val)
    // 路由
import router from './router';
import { loginByWebSiteWeixin } from "@/api/login";
router.beforeEach((to, from, next) => {
    if (to.query.code) {
        loginByWebSiteWeixin({ code: to.query.code }).then((res) => {;
            })
            .catch(err => {

            })
    }
    /* 路由发生变化的时候修改页面title */
    // if (to.meta.title) {
    //   document.title = to.meta.title;
    // }
    next();
});

// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'XKKq5vg1Br1RWEuieSdyicRAp1q7TCyG',
});

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
Vue.use(VueAwesomeSwiper /* { default options with global component } */ );

// 阻止生产提示
Vue.config.productionTip = false;

//域名地址
//开发
Vue.prototype.baseURL = process.env.VUE_APP_BASE_API

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');